export default __webpack_public_path__ + "static/media/Logo.37f99e29.svg";